export default __webpack_public_path__ + "static/media/bleibemobil-Logo-quer-4c.4eb2f630.png";